<div class="card shadow-sm filter-card">
  <div class="card-body">
    <form [formGroup]="filterForm">
      <div class="row g-3 align-items-end">
        <!-- Dynamic fields -->
        <div *ngFor="let field of fields" [ngClass]="field.colSize || 'col-md-4'">
          <label class="form-label fw-bold" [translate]="field.label"></label>
          
          <!-- Select field -->
          <ng-select
            *ngIf="field.type === 'select'"
            [items]="field.options"
            [bindLabel]="field.bindLabel || 'text'"
            [bindValue]="field.bindValue || 'value'"
            [formControlName]="field.name"
            [placeholder]="(field.placeholder || '$general.txtSelect') | translateAsync"
            [notFoundText]="(field.notFoundText || '$general.txtNoResultsFound') | translateAsync"
            [clearable]="field.clearable !== false"
            [searchable]="field.searchable !== false"
            [disabled]="isFieldDisabled(field)">
          </ng-select>

          <!-- Text field -->
          <input
            *ngIf="field.type === 'text'"
            type="text"
            class="form-control"
            [formControlName]="field.name"
            [placeholder]="(field.placeholder || '') | translateAsync"
            [disabled]="isFieldDisabled(field)">

          <!-- Number field -->
          <input
            *ngIf="field.type === 'number'"
            type="number"
            class="form-control"
            [formControlName]="field.name"
            [placeholder]="(field.placeholder || '') | translateAsync"
            [disabled]="isFieldDisabled(field)">

          <!-- Date field -->
          <input
            *ngIf="field.type === 'date'"
            type="date"
            class="form-control"
            [formControlName]="field.name"
            [disabled]="isFieldDisabled(field)">
        </div>

        <!-- Clear button -->
        <div *ngIf="showClearButton" class="col-md-4">
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fa-solid me-1" [ngClass]="clearButtonIcon"></i>
            <span translate>{{ clearButtonText }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
